import { createRouter, createWebHistory } from 'vue-router';
import Login from './views/Login.vue';
import Dashboard from './views/Dashboard.vue';
import ResetPassword from './views/ResetPassword.vue';
import { fetchUserInfo } from './services/user';
import Institutions from './views/Institutions.vue';
import Administration from './views/Administration.vue';
import Hospitals from './views/Hospitals.vue';
import Alerts from './views/Alerts.vue';
import LoginTaxis from './views/LoginTaxis.vue';
import DashboardInstitute from './views/DashboardInstitute.vue';
import ImportImplantStatement from './views/ImportImplantStatement.vue';
import StatedImplants from './views/StatedImplants.vue';
import ApplyImplantStatement from './views/ApplyImplantStatement.vue';
import ImplantsToApply from './views/ImplantsToApply.vue';
import AppliedImplants from './views/AppliedImplants.vue';
import AppliedImplantsHospital from './views/AppliedImplantsHospital.vue';
import ExpiredImplants from './views/ExpiredImplants.vue';
import TempSavedImplants from './views/TempSavedImplants.vue';
import TempSavedApplies from './views/TempSavedApplies.vue';
import TempSavedImplantsHospital from './views/TempSavedImplantsHospital.vue'
import DashboardHospital from './views/DashboardHospital.vue';
import ApplyImplantHospital from './views/ApplyImplantHospital.vue';
import HospitalsManual from './views/HospitalsManual.vue';
import InstitutionsManual from './views/InstitutionsManual.vue';
import SetToken from './views/SetToken.vue';

const routes = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
     meta: { layout: 'MainLayout', requiresAdmin: true }
  },
  {
    path: '/apply-implant-hospital',
    name: 'ApplyImplantHospital',
    component: ApplyImplantHospital,
    meta: { layout: 'MainLayoutHospital' }
  },
  {
    path: '/dashboard-hospital',
    name: 'DashboardHospital',
    component: DashboardHospital,
    meta: { layout: 'MainLayoutHospital' }
  },
  {
    path: '/temp-saved-implants',
    name: 'TempSavedImplants',
    component: TempSavedImplants,
    meta: { layout: 'MainLayoutInstitute' }
  },
  ,
  {
    path: '/temp-saved-applies',
    name: 'TempSavedApplies',
    component: TempSavedApplies,
    meta: { layout: 'MainLayoutInstitute' }
  },
  {
    path: '/temp-saved-implants-hospital',
    name: 'TempSavedImplantsHospital',
    component: TempSavedImplantsHospital,
    meta: { layout: 'MainLayoutHospital' }
  },
  {
    path: '/setToken',
    name: 'SetToken',
    component: SetToken,
    meta: { layout: 'MainLayout' }
  },
  {
    path: '/expired-implants',
    name: 'ExpiredImplants',
    component: ExpiredImplants,
    meta: { layout: 'MainLayoutInstitute' }
  },
  {
    path: '/applied-implants',
    name: 'AppliedImplants',
    component: AppliedImplants,
    meta: { layout: 'MainLayoutInstitute' }
  },
  {
    path: '/hospitals-manual',
    name: 'HospitalsManual',
    component: HospitalsManual,
    meta: { layout: 'MainLayoutHospital' }
  },
  {
    path: '/applied-implants-hospital',
    name: 'AppliedImplantsHospital',
    component: AppliedImplantsHospital,
    meta: { layout: 'MainLayoutHospital' }
  },
  {
    path: '/implants-to-apply',
    name: 'ImplantsToApply',
    component: ImplantsToApply,
    meta: { layout: 'MainLayoutInstitute' }
  },
  {
    path: '/apply-implant-statement',
    name: 'ApplyImplantStatement',
    component: ApplyImplantStatement,
    meta: { layout: 'MainLayoutInstitute' }
  },
  {
    path: '/dashboard-institute',
    name: 'DashboardInstitute',
    component: DashboardInstitute,
    meta: { layout: 'MainLayoutInstitute' }
  },
  {
    path: '/stated-implants',
    name: 'StatedImplants',
    component: StatedImplants,
    meta: { layout: 'MainLayoutInstitute' }
  },
  {
    path: '/import-implant-statement',
    name: 'ImportImplantStatement',
    component: ImportImplantStatement,
    meta: { layout: 'MainLayoutInstitute' }
  },
  {
    path: '/institutions-manual',
    name: 'InstitutionsManual',
    component: InstitutionsManual,
    meta: { layout: 'MainLayoutInstitute' }
  },
  {
    path: '/administration',
    name: 'administration',
    component: Administration,
    meta: { layout: 'MainLayout', requiresAdmin: true }
  },
  {
    path: '/institutions',
    name: 'Institutions',
    component: Institutions,
    meta: { layout: 'MainLayout', requiresAdmin: true }
  },
  {
    path: '/alerts',
    name: 'Alerts',
    component: Alerts,
    meta: { layout: 'MainLayout', requiresAdmin: true }
  },
  {
    path: '/hospitals',
    name: 'Hospitals',
    component: Hospitals,
    meta: { layout: 'MainLayout', requiresAdmin: true }
  },
  {
    path: '/',
    name: 'LoginTaxis',
    component: LoginTaxis,
    meta: { layout: 'LoginLayout' }
  },
  {
    path: '/eom-login',
    name: 'Login',
    component: Login,
    meta: { layout: 'LoginLayout' }
  },
  {
    path: '/reset-password',
    name: 'Reset Password',
    component: ResetPassword,
    meta: { layout: 'ResetPasswordLayout' }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});


router.beforeEach(async (to, from, next) => {
  // 🔁 Version/Build Check Before Navigation
  try {
    const res = await fetch('/version.json');
    const { version, build } = await res.json();
    const storedVersion = localStorage.getItem('app_version');
    const storedBuild = localStorage.getItem('app_build');

    if (version !== storedVersion || build !== storedBuild) {
      localStorage.setItem('app_version', version);
      localStorage.setItem('app_build', build);
      // Reload the whole app to load fresh JS/CSS
      location.reload();
      return; // Stop navigation
    }
  } catch (e) {
    console.warn('Failed to fetch version.json:', e);
    // Allow routing to continue even if version check fails
  }

  // 🔖 Meta Tags Handling
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  if (nearestWithMeta) {
    nearestWithMeta.meta.metaTags.forEach(tag => {
      const element = document.createElement('meta');
      Object.keys(tag).forEach(key => {
        element.setAttribute(key, tag[key]);
      });
      document.head.appendChild(element);
    });
  }

  // 🔐 Auth Guard
  const publicPages = ['Login', 'LoginTaxis', 'Reset Password', 'Register', 'SetToken'];
  const authRequired = !publicPages.includes(to.name);
  const token = localStorage.getItem('api_token');
  if (authRequired) {
    try {
      const userInfo = await fetchUserInfo();
      if (!userInfo || userInfo.data.info == null) {
        throw new Error('Invalid/expired token');
      }

       const user = userInfo.data.info;

      if (to.meta.requiresAdmin && user.admin !== 1) {
        if(user.usertype_id == 1){
          return next({ name: 'DashboardInstitute' });
        } else {
          return next({ name: 'DashboardHospital' });
        }
        
      
      }

      next();
    } catch (error) {
      localStorage.removeItem('api_token');
      next({ name: 'LoginTaxis' });
    }
  } else {
    if (token) {
      try {
        const userInfo = await fetchUserInfo();
        if (!userInfo || userInfo.data.info == null) {
          throw new Error('Invalid/expired token');
        }
        if (to.name === 'LoginTaxis') {
          next({ name: 'Dashboard' });
        } else {
          next();
        }
      } catch (error) {
        localStorage.removeItem('api_token');
        if (to.name !== 'LoginTaxis') {
          next({ name: 'LoginTaxis' });
        }
      }
    } else {
      next();
    }
  }
});
export default router;
